import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=76b49fe6&scoped=true&"
import script from "./Credits.vue?vue&type=script&lang=js&"
export * from "./Credits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../WebApp_Client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b49fe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../WebApp_Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VIcon,VRow,VSpacer})
